var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 800",
    style: {
      transform: "rotate(180deg)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#228BE6",
    d: "M0 0h1600v800H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2188e3",
    d: "M486 705.8c-109.3-21.8-223.4-32.2-335.3-19.4C99.5 692.1 49 703 0 719.8V800h843.8c-115.9-33.2-230.8-68.1-347.6-92.2-3.4-.7-6.8-1.3-10.2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2086e0",
    d: "M1600 0H0v719.8C49 703 99.5 692 150.7 686.3c111.9-12.7 226-2.4 335.3 19.4 3.4.7 6.8 1.4 10.2 2 116.8 24 231.7 59 347.6 92.2H1600V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e83dc",
    d: "M478.4 581c3.2.8 6.4 1.7 9.5 2.5C684.1 636 876.6 717 1081.4 760.1c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9 107.3-6.6 214.6 10.2 317.3 37z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d81d9",
    d: "M0 0v429.4c55.6-18.4 113.5-27.3 171.4-27.7 102.8-.8 203.2 22.7 299.3 54.5 3 1 5.9 2 8.9 3 183.6 62 365.7 146.1 562.4 192.1 186.7 43.7 376.3 34.4 557.9-12.6V0H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C7ED6",
    d: "M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1 2.8 1.1 5.5 2.3 8.3 3.4 171 71.6 342.7 158.5 531.3 207.7 198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2a483.5 483.5 0 01181.8-23.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b79cd",
    d: "M1600 0H0v136.3c62.3-20.9 127.7-27.5 192.2-19.2 93.6 12.1 180.5 47.7 263.3 89.6 2.6 1.3 5.1 2.6 7.7 3.9 158.4 81.1 319.7 170.9 500.3 223.2 210.5 61 430.8 49 636.6-16.6V0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a73c5",
    d: "M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3 12.8-4.1 25.4-8.4 38.1-12.9V0h-1312c56 21.3 108.7 50.6 159.7 82 2.4 1.4 4.7 2.9 7.1 4.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a6ebc",
    d: "M1600 0H498c118.1 85.8 243.5 164.5 386.8 216.2 191.8 69.2 400 74.7 595 21.1 40.8-11.2 81.1-25.2 120.3-41.7V0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1969b3",
    d: "M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8 21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4 174.9 70.7 368.7 88.7 552 47.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1864AB",
    d: "M1315.3 72.4c75.3-12.6 148.9-37.1 216.8-72.4h-723c157.7 71 335.6 101 506.2 72.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.4f2fdc9b3e132456e06e8fb7dd03fedb.svg";
export { ForwardRef as ReactComponent };